/*
 *  DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 *  THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 *  INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 *  HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 *  AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 *  THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 *  EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 *  Copyright (C) 2021 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 */

import {Button, Checkbox, Icon, Modal} from "@scuf/common";
import React from "react";
import {acceptUserDisclaimer} from "../api/Security";
import {injectIntl} from "react-intl";

class DisclaimerWindow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            checked: false,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.active !== this.props.active) {
            this.setState({open: this.props.active})
        }
    }

    doNotShowAgain = () => {
        acceptUserDisclaimer().then(() => this.props.onAccept());
    }

    render() {
        const {intl} = this.props

        return (
            <Modal closeIcon={true} onClose={() => this.setState({open: false})}
                   open={this.state.open}
                   closeOnDimmerClick={true}
                   size={"small"}>
                <Modal.Header>
                    <Icon key='icon-warning' name="badge-warning" size="xlarge"/>
                    <div className="disclaimer-header">{intl.formatMessage({id: "disclaimer.title"})}</div>
                </Modal.Header>
                <Modal.Content>
                    {intl.formatMessage({id: "disclaimer.content"})}
                    <div className="disclaimer-checkBox">
                        <Checkbox
                            label={intl.formatMessage({id: "disclaimer.doNotShowAgain"})}
                            checked={this.state.checked}
                            onChange={(checked) => {
                                this.setState({checked: checked});
                            }}
                        />
                    </div>
                </Modal.Content>
                <Modal.Footer>
                    <Button type="primary" size="medium" content={intl.formatMessage({id: "disclaimer.accept"})}
                            onClick={() => {
                                this.setState({open: false});
                                if (this.state.checked) {
                                    this.doNotShowAgain();
                                }
                            }}/>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default injectIntl(DisclaimerWindow)